module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("DIE SONNE")]), _vm._v(" brannte auf Lils Schultern, als er in der Schlange stand, um in das Boot einzusteigen. Es war wieder ein brütend heißer Tag mit hoher Luftfeuchtigkeit, aber durch die leichte Brise war es erträglicher. Da er in San Francisco lebte, war er an dieses Wetter nicht gewöhnt, aber er hatte an Sonnencreme gedacht und die nicht fettende Lotion mit Lichtschutzfaktor 45 großzügig auf seine Arme, seinen Nacken und seine Beine aufgetragen. Jody hatte ihm eine von Clarks Baseballkappen geliehen, um seinen Kopf und sein Gesicht zu schützen.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Grier trug erneut ein Tanktop, dieses Mal ein schwarzes mit einem neongrünen Aufdruck, der die Worte "), _c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Vinita Ice Cream")]), _vm._v(" zeigte. Der Schriftzug war von großen Kreisen in lebhaften Farben umgeben, die Eiskugeln darstellen sollten.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Dein T-Shirt ist sehr interessant.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich habe es entworfen“, sagte Grier stolz. „Gefällt es dir?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wie ich bereits gestern sagte, was sollte mir daran nicht gefallen?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich meinte das T-Shirt.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich weiß.“ Lil lächelte. Er konnte Griers Augen hinter der Sonnenbrille nicht sehen, aber sein verführerischer Tonfall bedeutete, dass sich seit gestern nichts zwischen ihnen geändert hatte. „Ich dachte, du bist Möbelpacker?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Unter anderem.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich mag es, wenn Männer viele Talente haben“, sagte Lil in flirtendem Tonfall.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„So bin ich. Ein wahres Allroundgenie.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Die Schlange bewegte sich und als sie endlich das Boot betraten, konnten sie wählen zwischen der Kabine und dem Deck, wo sie der Sonne ausgesetzt waren. „Was ist dir lieber?“, fragte Grier.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Auch wenn die Sonne tödlich ist und ich wahrscheinlich über Nacht altere, würde ich lieber auf dem Deck sitzen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Gute Wahl.“ Grier legte Lil die Hand an den Rücken und leitete ihn die schmale Eisentreppe auf das offene Deck hinauf. Ihre Plätze waren am Heck des Bootes und sie unterhielten sich, während sie warteten, bis alle Passagiere ihre Plätze eingenommen hatten.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Erzähl mir von Vinita Ice Cream“, sagte Lil. „Gehört es den Leuten, mit denen du gestern Abend zusammen warst?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ja. Die Garcias sind Freunde und Nachbarn und meine Familie hilft ihnen jedes Jahr am Stand.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Zu wem gehört der kleine Junge?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Luca ist der Sohn von Jillian. Sie ist Jakes Zwillingsschwester.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Jake?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Mein bester Freund.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Oh, richtig.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich kenne die Familie seit ich vier Jahre alt war.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wie alt bist du, wenn ich fragen darf?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich bin vor kurzem fünfundzwanzig geworden.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wann ist dein Geburtstag?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Am achtzehnten Juni.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ein Zwilling!“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ist das ein Problem?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Nein, es ist ein Vorteil. Zwillinge sind herrlich komplex.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Und ich dachte, ich wäre nur bipolar.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Lil lachte laut auf. „Ein wenig von beidem vielleicht?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Schon möglich“, sagte Grier lächelnd. „Was hast du für ein Sternzeichen?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Fische.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich kenne mich mit Astrologie nicht aus“, gab Grier zu.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Man sagt, Fische sind die besten Liebhaber.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ist das wahr oder nur ein Mythos?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Es hat sich noch niemand beschwert“, meinte Lil.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich mag Männer mit Erfahrung“, sagte Grier.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ach ja?“ Lil nahm Grier die Sonnenbrille ab, damit er ihm in die dunklen Augen sehen konnte, die ihn betrachteten. „Dann hast du den Jackpot gewonnen. Das ist einer der wenigen Vorteile, wenn man über dreißig ist.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Bist du einunddreißig?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Lil reichte ihm wieder seine Sonnenbrille, aber erst, nachdem er mit den Fingern über Griers Bart gestrichen und seine Lippen für einen sanften Kuss auf diesen üppigen Mund gedrückt hatte. Der Brünette lehnte sich in die Berührung und Lil sah zufrieden einen Funken der Lust in den obsidianfarbenen Augen, bevor sie hinter dem dunklen Glas verschwanden.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich bin siebenunddreißig“, flüsterte Lil.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Unmöglich.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Schmeicheleien bringen dich in diesem Fall weiter.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Es ist die Wahrheit“, versicherte Grier. „Du siehst nicht nach deinem Alter aus.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das hoffe ich doch schwer“, sagte Lil. „Trotzdem läuft die Zeit und plastische Chirurgie ist heutzutage nicht mehr so teuer.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„So weit bist du noch nicht.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Du bist süß“, sagte Lil, der das Kompliment genoss.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Erzähl mir von Lyndon Lyle Lampert“, bat Grier. „Hast du einen Partner?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Himmel, nein.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Glaubst du nicht an die Liebe?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Schon, aber ich habe noch nicht den Richtigen getroffen und mit weniger gebe ich mich nicht zufrieden.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Muss er übers Wasser gehen können?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Lil lachte. „Nicht unbedingt, aber er muss mein Herz zum Flattern, meinen Atem zum Stocken und meinen Schwanz zum Salutieren bringen. Nicht unbedingt in dieser Reihenfolge. Aber zwei von drei ist die Mindestanforderung.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich schätze, ich könnte dich bezirzen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ein "), _c('span', {
    staticClass: "calibre4"
  }, [_vm._v("True Blood")]), _vm._v("-Fan?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„"), _c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Vampire Diaries")]), _vm._v("“, gestand Grier. „Mein Herz hüpft jedes Mal, wenn der Bösewicht auf dem Bildschirm erscheint.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Damon ist ziemlich scharf, nicht wahr? Da möchte man freiwillig seinen Nacken entblößen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Unter anderem.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Du schlimmer Junge“, neckte Lil. „Gibt es jemand Besonderen in deinem Leben?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Dann wäre ich nicht hier, oder?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Oh, du bist einer dieser braven Jungs, die an Monogamie glauben.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Du etwa nicht?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich habe noch nie jemanden getroffen, für den ich sie in Erwägung gezogen hätte.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das kann ich mir kaum vorstellen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wir können nicht alle sein wie Clark und Jody.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich wünschte, ich wäre wie Clark.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Schätzchen, du bist genauso hinreißend, nur dass er wie ein nordischer Gott wirkt und du wie ein italienischer Bad Boy.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Scheiße“, murmelte Grier. „Ich bin kein bisschen wie Clark.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Was meinst du?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Er ist geoutet und stolz darauf.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Und du nicht?“ Das überraschte Lil, denn Grier hatte keine Scheu gehabt, ihn in der Öffentlichkeit zu küssen.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich nehme es zurück“, lenkte Grier ein. „Ich bin bei jedem out, außer meinem Vater.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Und seine Anerkennung ist dir am wichtigsten?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ja.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Was ist mit deiner Mutter?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Sie ist letztes Jahr gestorben.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das tut mir leid.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich vermisse sie sehr.“ Grier blickte zum Horizont und Lil konnte die Schwermut spüren, die den jungen Mann überkam, als die Erinnerungen hochkamen. „Ihre größte Sorge war, dass sie mich allein zurücklassen musste.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Lil legte den Arm um Grier und zog ihn an sich. „Sie war deine Freundin.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Grier nickte.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Glaub nicht, dass Clarks Entwicklung einfach war, Grier. Sein Vater ist ein homophober Größenwahnsinniger. Ich kann mir nicht vorstellen, dass dein Vater auch nur halb so schlimm ist.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich habe über Clarks Vater gelesen … Er scheint ein wenig kontrollsüchtig zu sein.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ein wenig ist eine Untertreibung.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Mein Dad ist ein guter Mensch, Lil. Er liebt mich und meinen Bruder und er hat hart gearbeitet, um uns eine Zukunft zu bieten. Leider kann er nicht verstehen, dass meine sexuelle Orientierung nicht so ist wie seine. Mom und ich wollten versuchen, ihn zu überzeugen, dass ich meine Ausbildung abschließen darf, aber dann wurde sie krank.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Du bist noch nicht mit dem College fertig?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Bisher habe ich es nur auf zwei Jahre allgemeine Ausbildung gebracht. Als ich auf das Illinois Institute of Art wechseln wollte, ist er durchgedreht.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wieso?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Nur Schwuchteln interessieren sich für Design.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Moment mal. Hat er noch nie von Frank Lloyd Wright gehört? Er war einer der besten Architekten, die es jemals gab, und er stammte aus dem Mittleren Westen, um Gottes willen. Und nach allem, was ich gehört habe, war er ein echter Schürzenjäger.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Lil, selbst wenn er von ihm gehört hätte, würde es keinen Unterschied machen. Alles, was Dad will, ist jemand, der Dilorio Trucking übernimmt, aber nicht einmal Ali ist daran interessiert.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wer ist Ali?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Mein Bruder Alissio.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich habt wirklich ungewöhnliche Namen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Lil ist auch nicht gerade alltäglich.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Touché.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wieso nennst du dich Lil? Mir wäre Lyndon lieber, denke ich.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Oh bitte. Lyndon klingt wie ein alter Sack. Als ich jünger war, und wirklich unerhört, haben meine Freunde mich Lilian genannt. Im Laufe der Jahre hat es sich abgekürzt.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Lilian.“ Grier runzelte die Stirn. „Das kann ich mir nicht vorstellen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Genug von mir, okay?“, meinte Lil, dem die alten Geschichten peinlich waren. Grier war erst acht Jahre alt gewesen, als Lil das Castro unsicher gemacht und sich den Spitznamen verdient hatte. Er beugte sich zu Grier und sagte: „Verschieben wir dieses Gespräch auf nach der Tour, in Ordnung?“ Endlich war das Boot voll und legte vom Dock ab.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Sicher.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Kopfhörer wurden ausgegeben und die zweistündige Fahrt begann. Der Erzähler beschrieb die vierzig verschiedenen Gebäude, die sie sehen würden, und fasste die Architekten von Chicago und ihre Werke zusammen. Lil fand es faszinierend, ebenso wie Grier, der die Tour schon mehrmals mitgemacht hatte. Nach einer Weile ging Grier nach unten zur Bar und holte zwei Flaschen Bier. Lil nahm sein Heineken dankbar an.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich bin besonders am Chicago Board of Trade Building und dem Sears Tower interessiert“, erzählte Lil. „Ich würde sie gern an Land besichtigen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das lässt sich arrangieren“, bot Grier an. „Der Name des Sears wurde übrigens in Willis Tower geändert.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wann war das?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„2009.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wie auch immer er heißt, ich möchte ihn gern sehen. Würdest du mitkommen?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich muss meine Schichten beim Taste tauschen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Da du mein Fremdenführer sein wirst, richte ich mich nach dir.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Als die Tour zu Ende war, hatten sie jeweils drei Bier getrunken und waren gut gelaunt. Beide Männer hatten einen leichten Sonnenbrand, aber Lil war überzeugt, dass die Rundfahrt ohne den Wind im Gesicht und dem Anblick der Sonne über dem Chicago River weit weniger Spaß gemacht hätte. Er hatte viel über die Architektur erfahren und hatte auch einen Einblick in Griers Welt bekommen. Sein neuer Bekannter war so viel mehr als ein hübsches Gesicht.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Hattest du Spaß?“, fragte Grier, während er sich auf Lils Arm stützte, um das Gleichgewicht zu halten. Von dem Bier und dem nun festen Boden unter ihren Füßen war ihnen schwummerig.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Es war toll“, sagte Lil. „Musst du heute nicht am Stand arbeiten?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich habe um einen freien Tag gebeten.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Gute Idee. Die Jungs wollen mit uns grillen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das klingt toll. Wo wohnen sie?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„In Bucktown.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das überrascht mich. Ich hätte erwartet, dass sie ein großes Haus in einem Vorort haben.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Sie haben ihr Haus in Berkeley behalten, deshalb haben sie in der Stadt vorerst etwas gemietet.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Bucktown ist nicht schlecht.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Mein erster Eindruck war nicht besonders gut.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Wie meinst du das?“, wollte Grier wissen. Sie mussten für ein Taxi anstehen.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich war zu Thanksgiving vor zwei Jahren zum ersten Mal hier. Es hat geschneit, war grau und trist. Ich fand es trostlos, als wir durch die Straßen gefahren sind und noch mehr, als wir zu ihrem Haus kamen.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ist es eine Bruchbude?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Nein, aber es war nicht das, was ich erwartet hatte.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Was hattest du denn erwartet?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„San Francisco“, sagte Lil lachend. „Es ist so anders.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das glaube ich, aber es ist eine typische Gegend in Chicago. Ist es ein enges Haus mit drei Stockwerken und einer Terrasse hinter dem Haus?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Woher weißt du das?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„So sind sie alle.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das Innere ihres Hauses ist toll. Das Äußere stört mich.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Grier neigte den Kopf. „Wieso?“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Die Häuser stehen praktisch übereinander und sind so alt. In San Francisco sind sie wenigstens bunt.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Du hast ein Problem mit dem Alter, scheint mir“, neckte Grier.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Ich mag offene Flächen und ja, ich gebe zu, dass brandneu besser ist als antik.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("„Das behalte ich im Hinterkopf, wenn ich für dich designe.“")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Lil hob eine Augenbraue, aber er antwortete nicht. Sie stiegen in das Taxi und Lil nannte dem Fahrer die Adresse von Clark und Jody.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d6d6aee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0007.vue
// module id = 75
// module chunks = 0